<template>
	<div style="padding-left: 20px; padding-right: 20px">
		<v-form ref="form">
			<costs-main-title :number-of-modules="numberOfModules" :module-number="moduleNumber"/>

			<costs-headers/>

			<administrative
				:readonly="readonly"
				:add-administrative="addAdministrative"
				:delete-administrative="deleteAdministrative"
				:move-administrative-up="moveAdministrativeUp"
				:move-administrative-down="moveAdministrativeDown"
				:administrative="administrative"
				:administrative-total="administrativeTotal"
				:options="options"
				:sync="sync"
				:add-cost-division="addAdministrativeCostDivision"
				:delete-cost-division="deleteAdministrativeCostDivision"
				:update-calculated="updateCalculated"
			/>

			<sum-of-administrative
				:total-administrative="totalAdministrative"
			/>

			<actions-costs
				:readonly="readonly"
				:actions="actions"
				:add-cost="addCost"
				:add-cost-division="addCostDivision"
				:delete-cost-division="deleteCostDivision"
				:move-administrative-up="moveCostUp"
				:move-administrative-down="moveCostDown"
				:costs="costs"
				:costs-key-value="costsKeyValue.toString()"
				:delete-cost="deleteCost"
				:options="options"
				:sync="sync"
				:update-calculated="updateCalculated"
				:actions-total="actionsTotal"
				:costs-total="costsTotal"
				:taken-serial-numbers="takenSerialNumbers"
			/>

			<sum-of-actions
				:total-actions="totalActions"
			/>

			<costs-limits-summary
				:administrative="relativeAdministrativeCosts"
				:administrative-title="relativeAdministrativeCostsTitle"
				:contribution="relativeContribution"
				:contribution-title="relativeContributionTitle"
			/>

			<sum-of-all
				:total-actions="totalActions"
				:total-administrative="totalAdministrative"
			/>
			<egranty-validation-error
				:error="error"
			></egranty-validation-error>
		</v-form>


	</div>

</template>

<script>
	import SumOfAdministrative from "./SumOfAdministrative";
	import SumOfAll from "./SumOfAll";
	import SumOfActions from "./SumOfActions";
	import Administrative from "./Administrative";
	import CostsMainTitle from "./CostsMainTitle";
	import CostsHeaders from "./CostsHeaders";
	import ActionsCosts from "./ActionsCosts";
	import EgrantyValidationError from "../../../../../genericComponents/EgrantyValidationError";
	import {Numbers} from "@/utils/Numbers";
	import CostsLimitsSummary from "./CostsLimitsSummary";

	export default {
		name: "ProjectCostsTable",

		mixins: [Numbers],

		components: {
			CostsLimitsSummary,
			EgrantyValidationError,
			ActionsCosts,
			CostsHeaders,
			CostsMainTitle,
			Administrative,
			SumOfActions,
			SumOfAll, SumOfAdministrative,
		},

		computed: {
			totalCosts () {
				let totalAdministrative = 0;
				let totalActions = 0;
				for (let i = 0; i < this.costs.length; i++) {
					let totalPartial = 0;
					for (let q = 0; q < this.costs[i].length; q++) {
						let cost = this.roundHalfUp(this.costs[i][q].pricePerUnit * this.costs[i][q].unitsCount);
						if (isNaN(cost)) {
							cost = 0;
						}
						totalPartial += cost;
					}
					totalActions += totalPartial;
				}
				for (let i = 0; i < this.administrative.length; i++) {
					let cost = this.roundHalfUp(this.administrative[i].pricePerUnit * this.administrative[i].unitsCount);
					if (isNaN(cost)) {
						cost = 0;
					}
					totalAdministrative += cost;
				}
				return (totalActions + totalAdministrative).toFixed(2);
			},

			relativeAdministrativeCosts () {
				if (this.offerConfiguration.percentAdministrativeRelativeToWholeCosts) {
					const val = this.totalAdministrative * 100 / this.totalCosts;
					if (!isNaN(val)) return (this.totalAdministrative * 100 / this.totalCosts).toFixed(2).replace(/\./g, ",") + " %";
					return "";
				} else {
					const val = this.totalAdministrative * 100 / this.costsSummary.dotation;
					if (!isNaN(val)) return (this.totalAdministrative * 100 / this.costsSummary.dotation).toFixed(2).replace(/\./g, ",") + " %";
					return "";
				}
			},

			relativeAdministrativeCostsTitle () {
				if (this.offerConfiguration.percentAdministrativeRelativeToWholeCosts) {
					return "Koszty administracyjne w odniesieniu do całości kosztów";
				} else {
					return "Koszty administracyjne w odniesieniu do wnioskowanej dotacji";
				}
			},

			relativeContributionTitle () {
				if (this.offerConfiguration.percentMinOwnContributionRelativeToWholeCosts ||
					this.offerConfiguration.percentMaxOwnContributionRelativeToWholeCosts) {
					return "Wkład własny w odniesieniu do całości kosztów";
				} else {
					return "Wkład własny w odniesieniu do wnioskowanej dotacji";
				}
			},

			relativeContribution () {
				if (this.offerConfiguration.percentMinOwnContributionRelativeToWholeCosts ||
					this.offerConfiguration.percentMaxOwnContributionRelativeToWholeCosts) {
					const val = this.totalContribution * 100 / this.totalCosts;
					if (!isNaN(val)) return (this.totalContribution * 100 / this.totalCosts).toFixed(2).replace(/\./g, ",") + " %";
					return "";
				} else {
					const val = this.totalContribution * 100 / this.costsSummary.dotation;
					if (!isNaN(val)) return (this.totalContribution * 100 / this.costsSummary.dotation).toFixed(2).replace(/\./g, ",") + " %";
					return "";
				}
			},

			financialContribution () {
				let part1 = parseFloat(this.costsSummary.ownFinancialContribution);
				let part2 = parseFloat(this.costsSummary.moneyFromRecipients);
				let part3 = parseFloat(this.costsSummary.otherPublicSource);
				let part4 = parseFloat(this.costsSummary.other);
				return ((isNaN(part1) ? 0 : part1) +
					(isNaN(part2) ? 0 : part2) +
					(isNaN(part3) ? 0 : part3) +
					(isNaN(part4) ? 0 : part4)).toFixed(2);
			},

			ownContribution () {
				let part1 = parseFloat(this.costsSummary.ownHumanContribution);
				let part2 = parseFloat(this.costsSummary.ownContributionInKind);
				return ((isNaN(part1) ? 0 : part1) +
					(isNaN(part2) ? 0 : part2)).toFixed(2);
			},

			totalContribution () {
				let part1 = parseFloat(this.ownContribution);
				let part2 = parseFloat(this.financialContribution);
				return ((isNaN(part1) ? 0 : part1) +
					(isNaN(part2) ? 0 : part2)).toFixed(2);

			},
		},

		methods: {

			sync () {
				this.reassignSerialNumbers();
				this.error = "";
				for (let actionCosts of this.costs) {
					for (let cost of actionCosts) {
						this.$set(cost, "errors", []);
					}
				}
				for (let cost of this.administrative) {
					this.$set(cost, "errors", []);
				}
				this.$emit("update:administrativeCosts", this.administrative);
				this.$emit("update:actionsCosts", this.costs);
				this.updateCalculated();

			},

			emptyCost () {
				let res =
					{
						name: "",
						costDivisions: [
							{
								type: "z dotacji",
								totalPrice: null,
							},
						],
						pricePerUnit: "",
						measureType: "",
					};
				return res;
			},

			reassignSerialNumbers () {
        if (this.readonly) return;

				for (let costIndex in this.costs) {

					for (let cost of this.costs[costIndex]) {
						if (!this.isCostSerialNumberPermanentlyTaken(costIndex, cost.serialNumber)) {
							cost.serialNumber = null;
						}
					}

					for (let cost of this.costs[costIndex]) {
						if (!this.isCostSerialNumberPermanentlyTaken(costIndex, cost.serialNumber)) {
							cost.serialNumber = this.getSerialNumber(costIndex);
						}
					}

					for (let administrative of this.administrativeCosts) {
						if (!this.isAdministrativeSerialNumberPermanentlyTaken(administrative.serialNumber)) {
							administrative.serialNumber = null;
						}
					}

					for (let administrative of this.administrativeCosts) {
						if (!this.isAdministrativeSerialNumberPermanentlyTaken(administrative.serialNumber)) {
							administrative.serialNumber = this.getAdministrativeSerialNumber();
						}
					}

					this.administrativeCosts = this.administrativeCosts.sort((a, b) => a.serialNumber - b.serialNumber);
					this.costs[costIndex] = this.costs[costIndex].sort((a, b) => a.serialNumber - b.serialNumber);
				}

			},

			isCostSerialNumberPermanentlyTaken (actionIndex, serialNumber) {
				if (this.takenSerialNumbers) {
					let actionSerialNumber = this.actions[actionIndex].serialNumber;
					for (let action of this.takenSerialNumbers.takenActionsSerialNumbers) {
						if (action.actionSerialNumber === actionSerialNumber) {
							for (var takenCostId of action.takenCostSerialNumbers) {
								if (takenCostId === serialNumber) {
									return true;
								}
							}
						}
					}
					return false;
				}
			},

			getSerialNumber (actionIndex) {
				let freeNumber = 0;
				let failed;
				do {
					failed = false;
					freeNumber++;
					for (let cost of this.costs[actionIndex]) {
						if (cost.serialNumber === freeNumber) {
							failed = true;
						}
					}
					if (this.isCostSerialNumberPermanentlyTaken(actionIndex, freeNumber)) {
						failed = true;
					}
				} while (failed);
				return freeNumber;
			},


			isAdministrativeSerialNumberPermanentlyTaken (serialNumber) {
				if (this.takenSerialNumbers) {
					for (let number of this.takenSerialNumbers.takenAdministrativeSerialNumbers) {
						if (number === serialNumber) {
							return true;
						}
					}
					return false;
				}
			},

			getAdministrativeSerialNumber () {
				let freeNumber = 0;
				let failed;
				do {
					failed = false;
					freeNumber++;
					for (let cost of this.administrativeCosts) {
						if (cost.serialNumber === freeNumber) {
							failed = true;
						}
					}
					if (this.isAdministrativeSerialNumberPermanentlyTaken(freeNumber)) {
						failed = true;
					}
				} while (failed);
				return freeNumber;
			},

			addAdministrative () {
				var toAdd = this.emptyCost();
				toAdd.serialNumber = this.getAdministrativeSerialNumber();
				this.administrative.push(toAdd);
				this.updateCalculated();
				this.sync();
			},

			addCost (index) {
				let toAdd = this.emptyCost();
				toAdd.serialNumber = this.getSerialNumber(index);
				this.costs[index].push(toAdd);
				this.updateCalculated();
				this.updateCostsKey();
				this.sync();
			},

			deleteCostDivision (actionIndex, costIndex, divisionIndex) {
				let cost = this.costs[actionIndex][costIndex];
				cost.costDivisions.splice(divisionIndex, 1);
				this.updateCalculated();
				this.updateCostsKey();
			},

			addCostDivision (actionIndex, costIndex) {
				this.costs[actionIndex][costIndex].costDivisions.push({
					type: null,
					totalPrice: null,
				});
				this.updateCostsKey();
			},

			addAdministrativeCostDivision (index) {
				this.administrative[index].costDivisions.push({
					type: null,
					totalPrice: null,
				});
			},

			deleteAdministrativeCostDivision (index, toRemoveIndex) {
				this.administrative[index].costDivisions.splice(toRemoveIndex, 1);
				this.updateCalculated();
			},

			deleteCost (actionIndex, index) {
				this.costs[actionIndex].splice(index, 1);
				this.updateCalculated();
				this.updateCostsKey();
				this.sync();
			},

      moveCostUp(actionIndex, index) {
        if (index === 0) return;
        let tmp = this.costs[actionIndex][index];
        this.costs[actionIndex][index] = this.costs[actionIndex][index - 1];
        this.costs[actionIndex][index - 1] = tmp;
        this.reassignSerialNumbers();
        this.updateCalculated();
        this.fixDataAfterChange();
        this.updateCostsSummary();
        this.updateCostsKey();
        this.sync();
      },

      moveCostDown(actionIndex, index) {
        if (index === this.costs[actionIndex].length - 1) return;
        let tmp = this.costs[actionIndex][index];
        this.costs[actionIndex][index] = this.costs[actionIndex][index + 1];
        this.costs[actionIndex][index + 1] = tmp;
        this.reassignSerialNumbers();
        this.updateCalculated();
        this.fixDataAfterChange();
        this.updateCostsSummary();
        this.updateCostsKey();
        this.sync();
      },

			updateCostsKey () {
				this.costsKeyValue++;
			},

			deleteAdministrative (index) {
				this.administrative.splice(index, 1);
				this.updateCalculated();
				this.sync();
			},

      moveAdministrativeUp (index) {
        if (index === 0) return;
        let tmp = this.administrative[index];
        this.administrative[index] = this.administrative[index - 1];
        this.administrative[index - 1] = tmp;
        let serialTmp = this.administrative[index].serialNumber;
        this.administrative[index].serialNumber = this.administrative[index - 1].serialNumber;
        this.administrative[index - 1].serialNumber = serialTmp;
        this.sync();
      },

      moveAdministrativeDown (index) {
        if (index === this.administrative.length - 1) return;
        let tmp = this.administrative[index];
        this.administrative[index] = this.administrative[index + 1];
        this.administrative[index + 1] = tmp;
        let serialTmp = this.administrative[index].serialNumber;
        this.administrative[index].serialNumber = this.administrative[index + 1].serialNumber;
        this.administrative[index + 1].serialNumber = serialTmp;
        this.sync();
      },

			updateCalculated () {
				this.totalAdministrative = 0;
				this.totalActions = 0;
				for (let i = 0; i < this.costs.length; i++) {
					if (this.costsTotal[i] === undefined) {
						this.$set(this.costsTotal, i, []);
					}
					let total = 0;
					for (let q = 0; q < this.costs[i].length; q++) {
						if (this.costs[i][q].pricePerUnit && this.costs[i][q].unitsCount) {
						this.$set(this.costsTotal[i], q, this.roundHalfUp(this.costs[i][q].pricePerUnit * this.costs[i][q].unitsCount));
						} else {
              this.$set(this.costsTotal[i], q, 0);
            }
						if (isNaN(this.costsTotal[i][q])) {
							this.$set(this.costsTotal[i], q, 0);
						}
						total += this.costsTotal[i][q];
						this.costs[i][q].costDivisions[0].totalPrice = 0;
						let given = this.costs[i][q].costDivisions.reduce((sum, current) => ((isNaN(parseFloat(current.totalPrice)) ? 0 : parseFloat(current.totalPrice)) + sum), 0);
						this.costs[i][q].costDivisions[0].totalPrice = Math.max(0, this.costsTotal[i][q] - given);
					}
					this.$set(this.actionsTotal, i, total);
					this.totalActions += total;
				}
				for (let i = 0; i < this.administrative.length; i++) {
					if (this.administrative[i].pricePerUnit && this.administrative[i].unitsCount) {
					this.$set(this.administrativeTotal, i, this.roundHalfUp(this.administrative[i].pricePerUnit * this.administrative[i].unitsCount));
					} else {
            this.administrativeTotal[i] = 0;
          }
					if (isNaN(this.administrativeTotal[i])) {
						this.administrativeTotal[i] = 0;
					}
					this.totalAdministrative += this.administrativeTotal[i];
					this.administrative[i].costDivisions[0].totalPrice = 0;
					let given = this.administrative[i].costDivisions.reduce((sum, current) => ((isNaN(parseFloat(current.totalPrice)) ? 0 : parseFloat(current.totalPrice)) + sum), 0);
					this.administrative[i].costDivisions[0].totalPrice = Math.max(0, this.administrativeTotal[i] - given);
				}

				this.keyValue++;
			},

			fixDataAfterChange () {
				if (this.readonly || !this.costsLoaded || !this.actionsLoaded || !this.idsLoaded) {
					return;
				}
				let index = 0;
				for (let action of this.actions) {
					if (this.costsActionsIds[index] !== action.id) {
						//jakieś pojedyncze działanie zostało po prostu usunięte
						if (this.costsActionsIds[index + 1] === action.id) {
							this.costs.splice(index, 1);
							this.costsActionsIds.splice(index, 1);
						} else {
							//pojawiło się jakieś nowe działanie
							this.costs[index] = [];
							this.costsActionsIds[index] = action.id;
						}
					}
					index++;
				}
				this.costs.length = this.actions.length;
				this.costsActionsIds.length = this.actions.length;
			},

			validateCost (cost) {
				this.$set(cost, "errors", []);

				if (cost.costDivisions.find(x => !x.type)) {
					cost.errors.push("Proszę uzupełnić źródła finansowania");
				}

				if (cost.costDivisions.length !== 1) {
					if (cost.costDivisions.find(x => !x.totalPrice && x.totalPrice !== 0)) {
						cost.errors.push("Proszę uzupełnić kwoty podziału kosztów źródła finansowania");
					} else {

						let expected = cost.pricePerUnit * cost.unitsCount;
						let given = cost.costDivisions.reduce((sum, current) => parseFloat(current.totalPrice) + sum, 0);
						if (Math.abs(given - expected) > 0.001) {
							cost.errors.push("Łączna suma kosztów nie jest równa iloczynowi liczby sztuk i ceny jednostkowej (powinno być " + Numbers.methods.formatMoney(expected) + ", a jest " + Numbers.methods.formatMoney(given) + ")");
						}
					}
				}
			},

			hasDotationCost (cost) {
				return cost.costDivisions.find(x => x.type === "z dotacji") !== undefined;
			},

			validate () {
				let errors = false;
				if (!this.$refs.form.validate()) {
					errors = true;
				}

				let anyDotationCost = false;

				for (let actionCosts of this.costs) {
					for (let cost of actionCosts) {
						this.validateCost(cost);
						anyDotationCost |= this.hasDotationCost(cost);
						errors |= cost.errors.length !== 0;
					}
				}

				for (let cost of this.administrative) {
					this.validateCost(cost);
					anyDotationCost |= this.hasDotationCost(cost);
					errors |= cost.errors.length !== 0;
				}

				if (anyDotationCost !== 1) {
					this.error = "Proszę dodać co najmniej jeden koszt ze źródłem finansowania rodzaju dotacja";
					errors = true;
				}

				return !errors;
			},

			updateCostsSummary () {
				let res = {
					dotation: 0,
					administrative: 0,
					ownFinancialContribution: 0,
					ownContributionInKind: 0,
					ownHumanContribution: 0,
					moneyFromRecipients: 0,
					other: 0,
					otherPublicSource: 0,
				};

				for (let array of this.costs) {
					for (let cost of array) {
						if (cost.costDivisions.length === 1) {
							this.processCost(res,
								{
									totalPrice: parseFloat(cost.pricePerUnit) * parseFloat(cost.unitsCount),
									type: cost.costDivisions[0].type,
								});
						} else {
							for (let division of cost.costDivisions) {
								this.processCost(res, division);
							}
						}
					}
				}

				for (let cost of this.administrative) {
					if (cost.costDivisions.length === 1) {
						this.processCost(res,
							{
								totalPrice: parseFloat(cost.pricePerUnit) * parseFloat(cost.unitsCount),
								type: cost.costDivisions[0].type,
							});
					} else {
						for (let division of cost.costDivisions) {
							this.processCost(res, division);
						}
					}
					res.administrative += parseFloat(cost.pricePerUnit) * parseFloat(cost.unitsCount);
				}

				for (let prop in res) {
					res[prop] = res[prop].toFixed(2);
				}
				this.costsSummary = res;
			},

			processCost (res, cost) {
				if (cost.type === undefined) {
					return;
				}
				if (cost.type === "z dotacji") {
					res.dotation += this.calculateCostTotal(cost);
				}
				if (cost.type === "środki finansowe własne") {
					res.ownFinancialContribution += this.calculateCostTotal(cost);
				}
				if (cost.type === "wkład osobowy") {
					res.ownHumanContribution += this.calculateCostTotal(cost);
				}
				if (cost.type === "wkład rzeczowy") {
					res.ownContributionInKind += this.calculateCostTotal(cost);
				}
				if (cost.type === "świadczenie pieniężne od odbiorców") {
					res.moneyFromRecipients += this.calculateCostTotal(cost);
				}
				if (cost.type === "pozostałe") {
					res.other += this.calculateCostTotal(cost);
				}
				if (cost.type === "środki finansowe z innych źródeł publicznych") {
					res.otherPublicSource += this.calculateCostTotal(cost);
				}
			},

			calculateCostTotal (cost) {
				var res = parseFloat(cost.totalPrice);
				return isNaN(res) ? 0 : res;
			},
		},

		data () {
			return {
				error: "",
				costs: [],
				costsActionsIds: [],
				administrative: [],
				actionsTotal: [],
				administrativeTotal: [],
				costsTotal: [],
				idsLoaded: false,
				costsLoaded: false,
				actionsLoaded: false,
				totalAdministrative: 0,
				totalActions: 0,
				options: [
					"środki finansowe własne",
					"wkład osobowy",
					"wkład rzeczowy",
					"świadczenie pieniężne od odbiorców",
					"pozostałe",
					"środki finansowe z innych źródeł publicznych",

				],
				keyValue: 0,
				costsKeyValue: 0,
				costsSummary: null,
			};

		},

		watch: {

			actionsCosts: {
				immediate: true,
				handler (val) {
					if (val === undefined) {
						val = [];
					}
					this.costs = val;
					this.updateCalculated();
					this.costsLoaded = true;
					this.fixDataAfterChange();
					this.updateCostsSummary();
				},
			},

			administrativeCosts: {
				immediate: true,
				handler (val) {
					if (val === undefined) {
						return;
					}
					this.administrative = val;
					this.updateCalculated();
					this.fixDataAfterChange();
					this.updateCostsSummary();
				},
			},

			actionsCostsActionsIds: {
				immediate: true,
				deep: true,
				handler (val) {
					if (val === undefined) {
						return;
					}
					this.costsActionsIds = val;
					this.idsLoaded = true;
					this.updateCalculated();
				},
			},

			actions: {
				immediate: true,
				deep: true,
				handler () {
					this.actionsLoaded = true;
					this.fixDataAfterChange();
				},
			},
		},

		props: {
			takenSerialNumbers: {},
			readonly: {
				default: false,
			},
			actions: {},
			actionsCosts: {},
			administrativeCosts: {},
			actionsCostsActionsIds: {},
			offerConfiguration: {},
			numberOfModules: {
				default: 0
			},
			moduleNumber: {
				default: ''
			},
		},
	};
</script>